import { render, staticRenderFns } from "./flow_node.vue?vue&type=template&id=037b56c7&scoped=true&"
import script from "./flow_node.vue?vue&type=script&lang=js&"
export * from "./flow_node.vue?vue&type=script&lang=js&"
import style0 from "./flow_node.vue?vue&type=style&index=0&id=037b56c7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b56c7",
  null
  
)

export default component.exports